import { takeEvery, fork, put, all, call } from "redux-saga/effects"

import i18n from "../../../../i18n"
import { API } from "../../../../api"
import { staticCountryAll } from "./slice"

export function* getData({ payload: { params } }) {
  try {
    const response = yield call(API.common.getCountries, params)

    const { data } = response

    yield put(staticCountryAll.getDataSuccess(data))
  } catch (error) {
    const message = error.response?.data?.message || i18n.t("error")
    yield put(staticCountryAll.getDataError(message))
  }
}

export function* watchGetData() {
  yield takeEvery(staticCountryAll.getData, getData)
}

function* allSaga() {
  yield all([fork(watchGetData)])
}

export default allSaga
